(() => {
  const ready = () => {
    document.querySelectorAll('.sx-mobile-menu a').forEach(a => a.addEventListener('click', () => { a.closest('details').open = false; }));
    const tabs = [...document.querySelectorAll('[data-collection-tab]')];
    const cards = [...document.querySelectorAll('[data-product-grid] [data-kind]')];
    const setCollection = kind => {
      tabs.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.collectionTab === kind)));
      cards.forEach(c => { c.hidden = c.dataset.kind !== kind; });
    };
    if (tabs.length) {
      setCollection('mystery');
      tabs.forEach(b => b.addEventListener('click', () => setCollection(b.dataset.collectionTab)));
      document.querySelectorAll('[data-show-sets]').forEach(a => a.addEventListener('click', () => setCollection('fixed')));
    }
    const form = document.querySelector('[data-sx-add]');
    if (!form) return;
    let messages;
    try { messages = JSON.parse(document.querySelector('[data-sx-messages]').textContent); } catch { return; }
    const button = form.querySelector('[data-sx-add-button]');
    const status = form.querySelector('[data-add-status]');
    const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: form.dataset.currency || 'USD' }).format(Number(cents) / 100);
    const inputs = [...form.querySelectorAll('input[type="radio"][name="id"]')];
    let busy = false;
    const offer = document.querySelector('[data-offer-deadline]');
    const deadline = offer ? Date.parse(offer.dataset.offerDeadline) : NaN;
    const hasDeadline = Number.isFinite(deadline);
    const offerEnded = () => form.dataset.offerExpired === 'true' || (hasDeadline && Date.now() >= deadline);
    const endOffer = () => {
      form.dataset.offerExpired = 'true';
      button.disabled = true;
      button.textContent = offer ? offer.dataset.offerEnded : 'Halloween offer ended';
    };
    if (hasDeadline) {
      const value = offer.querySelector('[data-countdown-value]');
      const tick = () => {
        const remaining = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        if (!remaining) { value.textContent = offer.dataset.offerEnded; endOffer(); return false; }
        const days = Math.floor(remaining / 86400);
        const hours = Math.floor(remaining / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;
        value.textContent = `${String(hours).padStart(2,'0')}h ${String(minutes).padStart(2,'0')}m ${String(seconds).padStart(2,'0')}s`;
        return true;
      };
      if (tick()) { const timer = window.setInterval(() => { if (!tick()) window.clearInterval(timer); }, 1000); }
    } else if (offerEnded()) endOffer();
    const changeVariant = input => {
      if (!input) return;
      document.querySelectorAll('[data-selected-price]').forEach(el => { el.textContent = money(input.dataset.price); });
      document.querySelector('[data-unit-price]').textContent = `${money(input.dataset.unit)} ${messages.unit}`;
      const offerLabel = document.querySelector('[data-selected-offer]');
      const savingLabel = document.querySelector('[data-selected-saving]');
      const count = Number(input.dataset.count);
      if (offerLabel) { offerLabel.textContent = count === 3 ? messages.offerThree : (count === 20 ? messages.offerTwenty : ''); offerLabel.hidden = count !== 3 && count !== 20; }
      if (savingLabel) { const separate = Number(form.dataset.singlePrice) * count; const saved = separate - Number(input.dataset.price); savingLabel.hidden = saved <= 0; savingLabel.textContent = messages.saving.replace('__AMOUNT__', money(saved)).replace('__PERCENT__', String(Math.round(saved / separate * 100))); }
      button.disabled = offerEnded() || input.dataset.available !== 'true';
      button.textContent = offerEnded() ? 'Halloween offer ended' : (button.disabled ? messages.unavailable : messages.add);
      status.textContent = '';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url);
    };
    inputs.forEach(input => input.addEventListener('change', () => changeVariant(input)));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (offerEnded()) { endOffer(); return; }
      if (busy || button.disabled) return;
      busy = true;
      form.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.textContent = messages.adding;
      const chosen = new FormData(form).get('id');
      inputs.forEach(input => { input.disabled = true; });
      status.textContent = '';
      try {
        const response = await fetch(`${messages.cartAddUrl}.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(chosen), quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || messages.error);
        window.location.assign(messages.cartUrl);
      } catch (error) {
        busy = false;
        form.setAttribute('aria-busy', 'false');
        inputs.forEach(input => { input.disabled = input.dataset.available !== 'true'; });
        button.disabled = offerEnded();
        button.textContent = offerEnded() ? 'Halloween offer ended' : messages.add;
        status.textContent = error instanceof Error ? error.message : messages.error;
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
